import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"
import LayerMenu from "../../layouts/header/LayerMenu"
import { useTranslation } from "react-i18next"
import * as Icons from "@bw/icons"

const Tab = styled(Link)`
  display: flex;
  text-decoration: none;
  width: 100%;
  flex-direction: column;
  position: relative;
  text-align: start;
  cursor: pointer;
  padding: 19px 10px;
  color: currentColor;
  font-weight: 300;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.003em;
  border: none;
  border-bottom: 1px solid var(--light-grey);
  :last-child {
    border: 0;
  }

  &.layer {
    font-size: 18px;
    padding: 25px 0 25px 10px;
    margin-left: 65px;

    @media (min-width: ${breakpoints.medium}px) {
      padding: 15px 0 15px 95px;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    padding: 25px 10px;
    font-size: 18px;
  }

  &.active {
    background: #f8f8f8;

    &:before {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 32px;
      right: 20px;
      border-radius: 50%;
      transform: translate(-250%; 40%);
      background-color: var(--page-color);
    }
  }
`

const Button = styled.button`
  display: flex;
  align-items: center;
  margin-top: 27px;
  background: none;
  border: none;
  color: var(--font-color);
  cursor: pointer;
  font-weight: 700;
  font-size: 15px;
  line-height: 176.3%;
`

const Mobile = styled.div`
  display: block;
  @media (min-width: ${breakpoints.medium}px) {
    display: none;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: ${breakpoints.medium}px) {
    display: block;
  }
`

const SideMenu = ({ tabs }) => {
  const { t } = useTranslation()
  const [show, setShow] = React.useState(false)
  return (
    <div>
      <Mobile>
        {tabs.slice(0, 3).map((item, i) => (
          <Tab key={i} to={item.to} activeClassName="active">
            {item.title}
          </Tab>
        ))}
        {tabs.length > 3 && (
          <Button
            onClick={e => {
              e.preventDefault()
              setShow(true)
              return false
            }}
          >
            <Icons.ArrowRight />
            <span style={{ marginLeft: "7px" }}>
              {t("sidemenu.seeAll", { count: tabs.length })}
            </span>
          </Button>
        )}
      </Mobile>
      <LayerMenu {...{ show, setShow }}>
        {tabs.map((item, i) => (
          <Tab key={i} to={item.to} activeClassName="active" className="layer">
            {item.title}
          </Tab>
        ))}
      </LayerMenu>
      <Desktop>
        {tabs.map((item, i) => (
          <Tab
            key={i}
            to={item.to}
            activeClassName="active"
            partiallyActive={true}
          >
            {item.title}
          </Tab>
        ))}
      </Desktop>
    </div>
  )
}

SideMenu.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

export { SideMenu }
